import React, { useState, useEffect } from 'react';
import { showOrgUnitGeneralInfoModal } from '../../../../actions/modal';
import { useDispatch } from 'react-redux';
import { forceValidation } from 'businessLogic/validation.js';
import { orgNameDuplicate, getOrgUnitWithSearchTerm } from 'actions/organisation';
import Info from '../../info';

export default function RightPanel(props) {
  const [updatingOrgUnitGeneralInfo, setUpdatingOrgUnitGeneralInfo] = useState(false);
  const dispatch = useDispatch();
  //  TODO: Use eventlistener & componentDidMount
  useEffect(() => {
    if (props.updateOrView == 'update') {
      if (props.messageData) {
        if (
          props.messageData.text.toString().indexOf(APP.LANGUAGE.OrgUnitGeneralInfo.OrgNameDuplicateErrorCheckString) !=
          -1
        ) {
          const orgNameInput = document.querySelectorAll('input[name="orgName"]');
          if (orgNameInput.length > 0) {
            orgNameInput.focus();
          }
        }
      }
    }
  }, [props.updateOrView, props.messageData]);

  const saveSharedWASettings = () => {
    setUpdatingOrgUnitGeneralInfo(true);
    let cb = (showModal, err) => {
      setUpdatingOrgUnitGeneralInfo(false);
      if (!showModal && props.isAdmin) {
        // for sys admin, refetch the new org unit data
        dispatch(
          getOrgUnitWithSearchTerm(props.selectedOrgUnit.networkId, () => {
            dispatch(showOrgUnitGeneralInfoModal(showModal));
          })
        );
      } else {
        dispatch(showOrgUnitGeneralInfoModal(showModal));
      }

      if (err == 'OrgNameDuplicate') {
        dispatch(orgNameDuplicate(true));
      }
    };
    props.saveButtonOnSave(cb);
  };

  useEffect(() => {
    // Force validation of the input fields
    let validation = () => {
      forceValidation(undefined, undefined, 'generalInfoOrgUnitForm');
    };
    setTimeout(validation, 50);
  }, []);

  const saveModalChange = (event) => {
    let areThereErrors = forceValidation(undefined, undefined, 'generalInfoOrgUnitForm');
    if (!areThereErrors && !event.target.className.includes('disable')) {
      saveSharedWASettings();
    }
  };

  const closeModal = () => {
    dispatch(showOrgUnitGeneralInfoModal(false));
  };

  const saveClasses =
    'ui disable labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';

  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className="mrts mrbl max-width">
          <button
            tabIndex={props.isAdmin ? '9' : '7'}
            type="button"
            name="saveBtn"
            data-group="generalInfoOrgUnitForm"
            onClick={saveModalChange}
            className={updatingOrgUnitGeneralInfo ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark icon" />
          </button>
          <button
            tabIndex={props.isAdmin ? '10' : '8'}
            type="button"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className=" mrbs max-width">
          <button
            onClick={closeModal}
            type="button"
            className="ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
      <div className="mrtl">
        <Info
          paragraphs={[
            APP.LANGUAGE.OrgUnitGeneralInfo.ITextInformation.replace('##orgName##', props.selectedOrgUnit.name),
            APP.LANGUAGE.OrgUnitGeneralInfo.ITextInformation2,
          ]}
        />
      </div>
    </div>
  );
}
